import * as moment from 'moment';
import * as _ from 'lodash';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-stat-card',
  templateUrl: './stat-card.component.html',
  styleUrls: ['./stat-card.component.scss'],
})
export class StatCardComponent implements OnChanges {
  @Input('label') public label: string = null;
  @Input('value') public value: number = 0;
  @Input('units') public units: string = null;

  public currentMonth: string = null;

  constructor(private storage: StorageService) {
    this.currentMonth = moment().format('MMM');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      let statRandomized = this.storage.get('statRandomized');
      if (!statRandomized || moment(statRandomized.dayExpiration).isBefore(moment())) {
        statRandomized = {
          dayValue: _.random(0, 10),
          dayExpiration: moment().endOf('day').toISOString(),
        };
        this.storage.put('statRandomized', statRandomized);
      }

      const monthDays = moment().daysInMonth();
      const currentDay = parseInt(moment().format('D'));
      this.value = (this.value / monthDays) * currentDay * ((100 + statRandomized.dayValue) / 100);
    }
  }
}
